import {
  CloseIcon,
  CloseCircleFilledIcon,
  DeleteIcon,
  CartIcon,
  EllipsisIcon,
  FolderIcon,
  FolderOpenIcon,
  SoundIcon,
  CallIcon,
  UserIcon,
  BrowseIcon,
  BrowseOffIcon,
  CheckCircleIcon,
  ErrorCircleIcon,
  LoadingIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowLeftStrokeIcon,
  AddIcon,
  RemoveIcon,
  SettingIcon,
  EditIcon,
  FileCopyIcon,
  MobileIcon,
  LogoWechatIcon,
  MailIcon,
  LogoQqIcon,
  ViewListIcon,
  ChartBarIcon,
  DownloadIcon,
  FilterIcon,
  InfoCircleIcon,
  CaretUpIcon,
  CaretDownIcon,
  CaretLeftIcon,
  CaretRightIcon,
  JumpIcon,
  Icon,
  RefreshIcon,
  Fullscreen2Icon,
  FullscreenExit2Icon,
  MoveIcon,
  NotificationFilledIcon,
  HelpCircleIcon,
  TimeIcon,
  NextIcon,
  PreviousIcon,
  SearchIcon,
  SwapIcon,
  // RoundIcon,
  MenuUnfoldIcon,
  CheckIcon,
  MinusCircleIcon,
  AddCircleIcon,
  QrcodeIcon,
  ServerIcon,
  LogoWindowsIcon,
  ChartPieIcon,
  BulletpointIcon,
  ForkIcon,
  DiscountIcon,
  GuideRectangleIcon,
  UserConfirmedIcon,
  SortIcon,
  PhoneConfirmedIcon,
  PhoneWarningIcon,
  PhoneErrorIcon,
  WechatConfirmedIcon,
  WechatWarningIcon,
  WechatErrorIcon,
  EmailConfirmedIcon,
  EmailWarningIcon,
  EmailErrorIcon,
  ViewGridIcon,
  ConvertipIcon,
  ChartLineIcon,
  MultiLineIcon,
  PercentIcon,
  TeachingIcon,
  // SettingFilledIcon,
  CurActiveIcon,
  FileDailyIcon,
  CurIcon,
} from "@tencent/tea-icons-react";
import React from "react";

export const teaIconsMap = {
  // close
  close: <CloseIcon />,
  // close-circle-filled
  dismiss: <CloseCircleFilledIcon />,
  // delete
  delete: <DeleteIcon />,
  // cart
  shopcart: <CartIcon />,
  // ellipsis
  more: <EllipsisIcon />,
  // folder
  folderclose: <FolderIcon />,
  // folder-open
  folderopen: <FolderOpenIcon />,
  // sound
  notice: <SoundIcon />,
  // empty
  guide: <GuideRectangleIcon />,
  // call
  consult: <CallIcon />,
  // user
  realname: <UserIcon />,
  // empty
  realnamev: (
    <UserConfirmedIcon
      colors={[
        { targetColor: "#000", reviseColor: "var(--tea-color-icon)" },
        {
          targetColor: "#00A870",
          reviseColor: "var(--tea-color-function-success-default)",
        },
      ]}
    />
  ),
  // browse
  show: <BrowseIcon />,
  // browse-off
  hide: <BrowseOffIcon />,
  // check-circle
  success: (
    <CheckCircleIcon color="var(--tea-color-function-success-default)" />
  ),
  // error-circle
  warning: (
    <ErrorCircleIcon color="var(--tea-color-function-warning-default)" />
  ),
  // loading
  loading: <LoadingIcon color="var(--tea-color-function-brand-default)" />,
  // error-circle
  error: <ErrorCircleIcon color="var(--tea-color-function-error-default)" />,
  // empty
  sort: <SortIcon />,
  // arrow-up
  sortup: <ArrowUpIcon />,
  // arrow-down
  sortdown: <ArrowDownIcon />,
  // arrow-left-stroke
  btnback: <ArrowLeftStrokeIcon />,
  // add
  plus: <AddIcon />,
  // remove
  minus: <RemoveIcon />,
  // setting
  setting: <SettingIcon />,
  // edit
  pencil: <EditIcon />,
  // file-copy
  copy: <FileCopyIcon />,
  // empty
  remind: null,
  // mobile
  phone: <MobileIcon />,
  // empty
  phonev: (
    <PhoneConfirmedIcon
      colors={[
        { targetColor: "#000", reviseColor: "var(--tea-color-icon)" },
        {
          targetColor: "#00A870",
          reviseColor: "var(--tea-color-function-success-default)",
        },
      ]}
    />
  ),
  // empty
  "phone-warning": (
    <PhoneWarningIcon
      colors={[
        { targetColor: "#000", reviseColor: "var(--tea-color-icon)" },
        {
          targetColor: "#F86F00",
          reviseColor: "var(--tea-color-function-warning-default)",
        },
      ]}
    />
  ),
  // empty
  "phone-error": (
    <PhoneErrorIcon
      colors={[
        { targetColor: "#000", reviseColor: "var(--tea-color-icon)" },
        {
          targetColor: "#D54941",
          reviseColor: "var(--tea-color-function-error-default)",
        },
      ]}
    />
  ),
  // logo-wechat
  wechat: <LogoWechatIcon />,
  // empty
  wechatv: (
    <WechatConfirmedIcon
      colors={[
        { targetColor: "#000", reviseColor: "var(--tea-color-icon)" },
        {
          targetColor: "#00A870",
          reviseColor: "var(--tea-color-function-success-default)",
        },
      ]}
    />
  ),
  // empty
  "wechat-warning": (
    <WechatWarningIcon
      colors={[
        { targetColor: "#000", reviseColor: "var(--tea-color-icon)" },
        {
          targetColor: "#F86F00",
          reviseColor: "var(--tea-color-function-warning-default)",
        },
      ]}
    />
  ),
  // empty
  "wechat-error": (
    <WechatErrorIcon
      colors={[
        { targetColor: "#000", reviseColor: "var(--tea-color-icon)" },
        {
          targetColor: "#D54941",
          reviseColor: "var(--tea-color-function-error-default)",
        },
      ]}
    />
  ),
  // mail
  email: <MailIcon />,
  // empty
  emailv: (
    <EmailConfirmedIcon
      colors={[
        { targetColor: "#000", reviseColor: "var(--tea-color-icon)" },
        {
          targetColor: "#00A870",
          reviseColor: "var(--tea-color-function-success-default)",
        },
      ]}
    />
  ),
  // empty
  "email-warning": (
    <EmailWarningIcon
      colors={[
        { targetColor: "#000", reviseColor: "var(--tea-color-icon)" },
        {
          targetColor: "#F86F00",
          reviseColor: "var(--tea-color-function-warning-default)",
        },
      ]}
    />
  ),
  // empty
  "email-error": (
    <EmailErrorIcon
      colors={[
        { targetColor: "#000", reviseColor: "var(--tea-color-icon)" },
        {
          targetColor: "#D54941",
          reviseColor: "var(--tea-color-function-error-default)",
        },
      ]}
    />
  ),
  // logo-qq
  qq: <LogoQqIcon />,
  // empty
  viewgrid: <ViewGridIcon />,
  // view-list
  viewlist: <ViewListIcon />,
  // chart-bar
  monitor: <ChartBarIcon />,
  // download
  download: <DownloadIcon />,
  // empty
  filter: <FilterIcon />,
  // empty
  "convertip--blue": (
    <ConvertipIcon color="var(--tea-color-function-brand-default)" />
  ),
  // empty
  convertip: <ConvertipIcon />,
  // info-circle
  info: <InfoCircleIcon />,
  // caret-up
  arrowup: <CaretUpIcon />,
  // empty
  arrowdown: <CaretDownIcon />,
  // empty
  arrowleft: <CaretLeftIcon />,
  // empty
  arrowright: <CaretRightIcon />,
  // jump
  externallink: <JumpIcon color="var(--tea-color-function-brand-default)" />,
  // refresh
  refresh: <RefreshIcon />,
  // refresh
  "refresh-blue": (
    <RefreshIcon color="var(--tea-color-function-brand-default)" />
  ),
  // fullscreen
  fullscreen: <Fullscreen2Icon />,
  // fullscreen-exit
  fullscreenquit: <FullscreenExit2Icon />,
  // arrow-down
  trenddown: (
    <ArrowDownIcon color="var(--tea-color-function-success-default)" />
  ),
  // arrow-up
  trendup: <ArrowUpIcon color="var(--tea-color-function-error-default)" />,
  // move
  drop: <MoveIcon />,
  // notification-filled
  news: <NotificationFilledIcon />,
  // help-circle
  help: <HelpCircleIcon />,
  // time
  "pending-gray": <TimeIcon />,
  // time
  pending: <TimeIcon color="var(--tea-color-function-warning-default)" />,
  // info-circle
  infoblue: <InfoCircleIcon color="var(--tea-color-function-brand-default)" />,
  // next
  lastpage: <NextIcon />,
  // previous
  firstpage: <PreviousIcon />,
  // search
  search: <SearchIcon />,
  // swap
  transfer: <SwapIcon />,
  // round
  cur: <CurIcon />,
  // empty
  "cur-active": <CurActiveIcon />,
  // menu-unfold
  fold: <MenuUnfoldIcon />,
  // check
  check: <CheckIcon />,
  // minus-circle
  not: <MinusCircleIcon />,
  // add-circle
  and: <AddCircleIcon color="var(--tea-color-function-success-default)" />,
  // qrcode
  qrcode: <QrcodeIcon />,
  // server
  database: <ServerIcon />,
  // logo-windows
  datasheet: <LogoWindowsIcon />,
  // empty
  daily: <FileDailyIcon />,
  // chart-pie
  "chart-pie": <ChartPieIcon />,
  // chart-pie
  "chart-pie-hover": (
    <ChartPieIcon color="var(--tea-color-function-brand-default)" />
  ),
  // empty
  "chart-line": <ChartLineIcon />,
  // empty
  "chart-line-hover": (
    <ChartLineIcon color="var(--tea-color-function-brand-default)" />
  ),
  // chart-bar
  "chart-column": <ChartBarIcon />,
  // chart-bar
  "chart-column-hover": (
    <ChartBarIcon color="var(--tea-color-function-brand-default)" />
  ),
  // bulletpoint
  table: <BulletpointIcon />,
  // bulletpoint
  "table-hover": (
    <BulletpointIcon color="var(--tea-color-function-brand-default)" />
  ),
  // fork
  relationship: <ForkIcon />,
  // fork
  "relationship-hover": (
    <ForkIcon color="var(--tea-color-function-brand-default)" />
  ),
  // empty
  "multi-line": <MultiLineIcon />,
  // empty
  percent: <PercentIcon />,
  // empty
  "percent-blue": (
    <PercentIcon color="var(--tea-color-function-brand-default)" />
  ),
  // discount
  tag: <DiscountIcon />,
  // empty
  teaching: <TeachingIcon color="var(--tea-color-function-brand-default)" />,
  detail: <EllipsisIcon />,
};
